// extracted by mini-css-extract-plugin
module.exports = {"logo":"Watermark_logo__v_VP5","copy":"Watermark_copy__qU2ub"};